import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import axios from "axios";

const AddCouponsDashboard = () => {
  const [couponName, setCouponName] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [adPost, setAdPost] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [percentage, setPercentage] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [requestedSlotId, setRequestedSlotId] = useState('');
  const [status, setStatus] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  const [assignedSlotId, setAssignedSlotId] = useState("");
  const [isApproved, setIsApproved] = useState(false);
  const [merchantId, setMerchantId] = useState("");
  const [merchantURL, setMerchantURL] = useState("");
  const [error, setError] = useState('');

  const merchantproductsite = `bakpoket.com/merchantproductsite/${merchantId}`;
  const fileInputRef = useRef(null);

  useEffect(() => {
    const merchantData = localStorage.getItem("merchantLogin");
    const googleLogin = localStorage.getItem('googleLogin');
    if (googleLogin === "false") {
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const merchantIdVal = parsedData.merchantId || parsedData.id;
        if (merchantIdVal) setMerchantId(merchantIdVal.toString());
      }
    } else {
      const merchantDashboardLogin = localStorage.getItem("merchantDashboardLogin");
      if (merchantDashboardLogin) {
        const parsedData = JSON.parse(merchantDashboardLogin);
        const merchantIdVal = parsedData.merchantId || parsedData.id;
        if (merchantIdVal) setMerchantId(merchantIdVal.toString());
      }
    }
  }, []);

  useEffect(() => {
    if (merchantId) {
      axios.get(`https://api.bakpoket.com/api/MerchantDetails/${merchantId}`)
        .then((res) => {
          setMerchantURL(
            res.data.merchatSiteUrl && res.data.merchatSiteUrl.trim() !== ""
              ? res.data.merchatSiteUrl
              : merchantproductsite
          );
        })
        .catch((err) => console.error(err));
    }
  }, [merchantId]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setIssueDate(today);
  }, []);

  useEffect(() => {
    if (requestedSlotId) {
      if (!requestedSlotId || requestedSlotId <= 0 || requestedSlotId > 24) {
        setError("Requested Slot Id must be greater than 0 and less than or equal to 24");
      } else {
        setError(""); 
      }
    }
  }, [requestedSlotId]);

  // Regex for yyyy/mm/dd or yyyy-mm-dd
  const dateRegex = /^(19|20)\d\d[-/](0[1-9]|1[0-2])[-/](0[1-9]|[12][0-9]|3[01])$/;

  const handleExpiryChange = (e) => {
    const value = e.target.value;
    setExpiryDate(value);

    if (!dateRegex.test(value)) {
      setError("Enter expiry date in yyyy/mm/dd format");
    } else {
      // Check if real date exists
      const [year, month, day] = value.split(/[-/]/).map(Number);
      const validDate = new Date(year, month - 1, day);
      if (validDate.getFullYear() !== year || validDate.getMonth() + 1 !== month || validDate.getDate() !== day) {
        setError("Invalid date entered");
      } else {
        setError(""); // valid date
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!requestedSlotId || requestedSlotId <= 0 || requestedSlotId > 24) {
      setError("Requested Slot Id must be greater than 0 and less than or equal to 24");
      return;
    }

    if (!dateRegex.test(expiryDate)) {
      setError("Enter expiry date in yyyy/mm/dd format");
      return;
    }
    const [year, month, day] = expiryDate.split(/[-/]/).map(Number);
    const validDate = new Date(year, month - 1, day);
    if (validDate.getFullYear() !== year || validDate.getMonth() + 1 !== month || validDate.getDate() !== day) {
      setError("Invalid expiry date");
      return;
    }

    const formData = new FormData();
    formData.append('couponName', couponName);
    formData.append('couponCode', couponCode);
    formData.append('expiryDate', expiryDate);
    formData.append('termsAndConditions', termsAndConditions);
    formData.append('adPost', adPost);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('percentage', percentage);
    formData.append('discountValue', discountValue);
    formData.append('requestedSlotId', requestedSlotId);
    formData.append('status', status);
    formData.append('issueDate', issueDate);
    formData.append('assignedSlotId', assignedSlotId);
    formData.append('isApproved', isApproved);
    formData.append('merchantId', merchantId);
    formData.append('merchantURL', merchantURL);

    try {
      const response = await axios.post(
        'https://api.bakpoket.com/api/MerchantDetails/coupons/upload',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      alert('Coupon added successfully!');
      setCouponName('');
      setCouponCode('');
      setExpiryDate('');
      setTermsAndConditions('');
      setPercentage('');
      setDiscountValue('');
      setAdPost(null);
      setRequestedSlotId('');
      setTitle('');
      setDescription('');
      setAssignedSlotId('');
      fileInputRef.current.value = null;
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Upload failed. Please check the fields.');
    }
  };

  return (
    <Wrapper>
      <h3 className="text-center text-md-start">Create New Coupons</h3>
      <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr" />
      <div className="AddCouponsDashboard">
        <form onSubmit={handleSubmit}>
          <div className="form-first-div">
            <input
              placeholder="Coupon Name"
              className="input1"
              value={couponName}
              onChange={(e) => setCouponName(e.target.value)}
              required
            />
            <input
              placeholder="Coupon Code"
              className="input2"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              required
            />
            <input
              placeholder="Expire date yyyy/mm/dd"
              type="text"
              className="input3 w-100"
              id="dateexpire"
              value={expiryDate}
              onChange={handleExpiryChange}
              required
            />
          </div>

          <input
            placeholder="Terms & Conditions"
            className="input-terms"
            type="text"
            value={termsAndConditions}
            onChange={(e) => setTermsAndConditions(e.target.value)}
            required
          />

          <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr" />

          <input
            placeholder="Percentage %"
            className="input-persentage"
            type="number"
            value={percentage}
            onChange={(e) => setPercentage(e.target.value)}
            required
          />

          <input
            placeholder="Discount Value"
            className="input-persentage"
            type="number"
            value={discountValue}
            onChange={(e) => setDiscountValue(e.target.value)}
            required
          />

          <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr" />

          <div className="form-first-div mt-2">
            <input
              placeholder="Upload Ad"
              className="uplode-img"
              type="file"
              accept=".jpg,.jpeg,.png"
              ref={fileInputRef}
              onChange={(e) => setAdPost(e.target.files[0])}
              required
            />
            <p className="para">
              Please upload JPG or PNG file.<br />
              With dimensions 270x255. <br /> The file should not exceed 2MB.
            </p>
            <input
              className="input3"
              placeholder="Requested Slot Id"
              type="number"
              value={requestedSlotId}
              onChange={(e) => setRequestedSlotId(e.target.value)}
              required
            />
          </div>

          <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr" />

          <input
            placeholder="Title"
            className="input-persentage"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />

          <input
            placeholder="Description"
            className="input-persentage"
            value={description}
            type="text"
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr" />

          {error && <div className="d-flex justify-content-center mb-2">
            <small className="text-danger">{error}</small>
          </div>}

          <button className="btn">Submit</button>
        </form>

        <hr style={{ border: "0.5px solid black", opacity: 0.4 }} className="hr1" />

        <p>
          Use promo code BAKPO2025 at checkout to enjoy exclusive savings on
          purchase. Hurry-this limited-time deals won't last long.Shop now and
          save big!
        </p>
      </div>
    </Wrapper>
  );
};



const Wrapper = styled.section`
  background-color: #fff;
  width: 100%;
  max-width: 1280px;
  margin: 2% auto;
  padding: 30px;
  border-radius: 15px;

  @media (max-width: 974px) {
    padding: 15px;
    hr {
      margin-top: 0px;    }
  }

  h3 {
    color: #2a4157;
    font-weight: bold;
    @media (max-width: 480px) {
      font-size: 12px;
      margin-bottom: 0 !important;
    }
    @media (max-width: 974px) {
      margin-bottom: 0;
    }
  }

  .btn {
    padding: 8px 40px;
    background-color: #ef4766;
    color: #fff;
    border-radius: 20px;
    margin-left: 42%;
    @media (max-width: 480px) {
      padding: 3px 18px;
      margin-top: 0px;
      margin-left: 35%;
    }
  }

  .AddCouponsDashboard {
    display: flex;
    flex-direction: column;
  }

  form {
    width: 100%;
    padding: 0px 20px 20px 20px;

    input {
      padding: 20px 0px 20px 20px;
      border-radius: 20px;
      border: 1px solid #999999;
      margin-bottom: 10px;
      @media (max-width: 480px) {
        padding: 4px;
        font-size: 8px;
        margin-bottom: 5px;
      }
    }

    @media (max-width: 974px) {
      padding: 4px;
    }
  }

  .hr {
    margin-bottom: 15px;
    margin-top:4px;
    @media(max-width: 974px){
      margin-bottom: 5px;
    }
  }

  .hr1 {
    margin-top: 0;
    @media (max-width: 974px) {
      display: none;
    }
  }

  p {
    padding: 15px;
    font-size: 15px;
    width: 90%;
    line-height: 1.4;
    color: #333;
    @media (max-width: 974px) {
      font-size: 11px;
      padding: 10px;
      display: none;
    }
  }

  .form-first-div {
    display: flex;
    gap: 20px;
    @media (max-width: 974px) {
      flex-direction: column;
      gap: 1px;
    }
  }

  .input1,
  .input2 {
    flex: 1;
  }

  .input3 {
    flex: 1;
  }

  .input-terms {
    width: 100%;
  }

  .input-persentage {
    width: 20%;
    margin-right: 4%;
    @media (max-width: 974px) {
      width: 100%;
    }
  }

  .uplode-img {
    width: 40%;
    @media (max-width: 974px) {
      width: 100%;
    }
  }

  .para {
    font-size: 12px;
    color: #999;
    margin: 0;
    width: 35%;
    @media (max-width: 974px) {
      font-size: 10px;
      width: 100%;
    }
  }
`;

export default AddCouponsDashboard;
